import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getBCAPendingIcon,
  getPersonIcon,
  getAssignIcon,
  getViewIcon,
  getTrialAssignIcon,
} from "../MemberReportMocks.js";
import "../../../../styles/member-report/member-detailed-report.css";
import { convertTo12HourFormat } from "../../../common-data/Converts.js";
import PaginationBar from "../../../lead-management/lms-v2/lms-customised-comps/PaginationBar.jsx";
import CalendarLoader from "../../../common-components/CalendarLoader.jsx";

const MemberDetailedReport = ({ allFilters, setAllFilters, setModValues }) => {
  const {
    gymSegmentMembersBP,
    gymSegmentMembersBPLoading,
    gymSegmentMembersBPError,

    gymSegmentMembersTrial,
    gymSegmentMembersTrialLoading,
    gymSegmentMembersTrialError,

    gymSegmentMembersUnassigned,
    gymSegmentMembersUnassignedLoading,
    gymSegmentMembersUnassignedError,
  } = useSelector((state) => state.prospects);

  const iniData = {
    bcaPendingData: [],
    bcaPendingPagination: [],

    trialData: [],
    trialPagination: [],

    unassignedData: [],
    unassignedPagination: [],
  };
  const [allData, setAllData] = useState(iniData);

  useEffect(() => {
    if (
      !gymSegmentMembersBPLoading &&
      !gymSegmentMembersBPError &&
      gymSegmentMembersBP?.status
    ) {
      setAllData((prevs) => ({
        ...prevs,
        bcaPendingData: gymSegmentMembersBP?.data,
        bcaPendingPagination: gymSegmentMembersBP?.pagination,
      }));
    } else {
      setAllData((prevs) => ({
        ...prevs,
        bcaPendingData: [],
        bcaPendingPagination: [],
      }));
    }
  }, [
    gymSegmentMembersBPLoading,
    gymSegmentMembersBPError,
    gymSegmentMembersBP,
  ]);

  useEffect(() => {
    if (
      !gymSegmentMembersTrialLoading &&
      !gymSegmentMembersTrialError &&
      gymSegmentMembersTrial?.status
    ) {
      setAllData((prevs) => ({
        ...prevs,
        trialData: gymSegmentMembersTrial?.data,
        trialPagination: gymSegmentMembersTrial?.pagination,
      }));
    } else {
      setAllData((prevs) => ({
        ...prevs,
        trialData: [],
        trialPagination: [],
      }));
    }
  }, [
    gymSegmentMembersTrialLoading,
    gymSegmentMembersTrialError,
    gymSegmentMembersTrial,
  ]);

  useEffect(() => {
    if (
      !gymSegmentMembersUnassignedLoading &&
      !gymSegmentMembersUnassignedError &&
      gymSegmentMembersUnassigned?.status
    ) {
      setAllData((prevs) => ({
        ...prevs,
        unassignedData: gymSegmentMembersUnassigned?.data,
        unassignedPagination: gymSegmentMembersUnassigned?.pagination,
      }));
    } else {
      setAllData((prevs) => ({
        ...prevs,
        unassignedData: [],
        unassignedPagination: [],
      }));
    }
  }, [
    gymSegmentMembersUnassignedLoading,
    gymSegmentMembersUnassignedError,
    gymSegmentMembersUnassigned,
  ]);

  const renderMemberCard = (member, memberType) => (
    <div key={member.user_id} className="mr-member-card">
      <div className="mr-member-left">
        <div className="mr-member-content">
          <div className="mr-member-name">{member.user_name}</div>
          <div className="mr-member-meta">
            {member.member_checkin_time && (
              <span className="mr-member-time">
                {getBCAPendingIcon("mr-member-icon")}
                {convertTo12HourFormat(member.member_checkin_time)}
              </span>
            )}
            {member?.not_started ? (
              <span className="mr-member-chip mr-member-chip--red">
                trial not started
              </span>
            ) : member.trial_days !== undefined &&
              member.trial_days !== null ? (
              <span
                className={`mr-member-chip ${
                  parseInt(member.trial_days) === 1
                    ? "mr-member-chip--trial-day-1"
                    : parseInt(member.trial_days) === 2
                    ? "mr-member-chip--trial-day-2"
                    : parseInt(member.trial_days) === 3
                    ? "mr-member-chip--trial-day-3"
                    : "mr-member-chip--neutral"
                }`}
              >
                Trial Day {parseInt(member.trial_days) || 0}
              </span>
            ) : null}
          </div>
        </div>
      </div>
      <div className="mr-member-right">
        {member.trainer_name && (
          <span className="mr-member-chip mr-member-chip--success">
            {getPersonIcon()} 
            trainer: {member.trainer_name}
          </span>
        )}

        {/* {!member.trainer_name && memberType === "unassigned" && (
          <span className="mr-member-chip mr-member-chip--danger">
            {getCrossTickIcon()}
            Unassigned
          </span>
        )} */}

        <div className="mr-member-actions">
          {memberType === "unassigned" && (
            <button
              className="mr-member-action-btn mr-member-action-btn--assign"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "trainer_member_map",
                  rowData: member,
                }));
              }}
              title="Assign trainer to this member"
            >
              {getAssignIcon()}
              Map Trainer
            </button>
          )}

          {memberType === "trial" && (
            <button
              className="mr-member-action-btn mr-member-action-btn--trial"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "trial_assign",
                  rowData: member,
                }));
              }}
              title="Assign trial to this member"
            >
              {getTrialAssignIcon()}
              {member?.not_started ? "Assign" : "Re-Assign"}
            </button>
          )}

          {memberType === "bca_pending" && (
            <button
              className="mr-member-action-btn mr-member-action-btn--view"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "BCA_history",
                  rowData: member,
                }));
              }}
              title="View BCA history for this member"
            >
              {getViewIcon()}
              View BCA
            </button>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <section
      className="mr-members-section"
      aria-label="Member management dashboard"
    >
      <div className="mr-members-grid">
        {gymSegmentMembersUnassignedLoading ? (
          <CalendarLoader daysCount={1} shiftsPerDay={4} />
        ) : allData.unassignedData.length > 0 ? (
          <div className="mr-members-column">
            <div className="mr-members-header">
              <h3 className="mr-members-title">Unassigned Members</h3>
              <span className="mr-members-count">
                {allData.unassignedData.length} members
              </span>
            </div>

            <div className="mr-members-list">
              {allData.unassignedData.map((member) =>
                renderMemberCard(member, "unassigned")
              )}
            </div>

            {allData.unassignedData.length > 10 ? (
              <PaginationBar
                paginationArray={allData.unassignedPagination}
                isPage={allFilters.isUnassignedPage}
                setIsPage={(value) =>
                  setAllFilters((prevs) => ({
                    ...prevs,
                    isUnassignedPage: value,
                  }))
                }
                pageLimit={allFilters.pageLimit}
                setPageLimit={(value) =>
                  setAllFilters((prevs) => ({ ...prevs, pageLimit: value }))
                }
              />
            ) : null}
          </div>
        ) : null}

        {gymSegmentMembersTrialLoading ? (
          <CalendarLoader daysCount={1} shiftsPerDay={4} />
        ) : allData.trialData.length > 0 ? (
          <div className="mr-members-column">
            <div className="mr-members-header">
              <h3 className="mr-members-title">Trial Members</h3>
              <span className="mr-members-count">
                {allData.trialData.length} members
              </span>
            </div>
            <div className="mr-members-list">
              {allData.trialData.map((member) =>
                renderMemberCard(member, "trial")
              )}
            </div>

            {allData.trialData.length > 10 ? (
              <PaginationBar
                paginationArray={allData.trialPagination}
                isPage={allFilters.isTrialPage}
                setIsPage={(value) =>
                  setAllFilters((prevs) => ({
                    ...prevs,
                    isTrialPage: value,
                  }))
                }
                pageLimit={allFilters.pageLimit}
                setPageLimit={(value) =>
                  setAllFilters((prevs) => ({ ...prevs, pageLimit: value }))
                }
              />
            ) : null}
          </div>
        ) : null}

        {gymSegmentMembersBPLoading ? (
          <CalendarLoader daysCount={1} shiftsPerDay={4} />
        ) : allData.bcaPendingData.length > 0 ? (
          <div className="mr-members-column">
            <div className="mr-members-header">
              <h3 className="mr-members-title">BCA Pending</h3>
              <span className="mr-members-count">
                {allData.bcaPendingData.length} members
              </span>
            </div>
            <div className="mr-members-list">
              {allData.bcaPendingData.map((member) =>
                renderMemberCard(member, "bca_pending")
              )}
            </div>

            {allData.bcaPendingData.length > 10 ? (
              <PaginationBar
                paginationArray={allData.bcaPendingPagination}
                isPage={allFilters.isBCAPage}
                setIsPage={(value) =>
                  setAllFilters((prevs) => ({
                    ...prevs,
                    isBCAPage: value,
                  }))
                }
                pageLimit={allFilters.pageLimit}
                setPageLimit={(value) =>
                  setAllFilters((prevs) => ({ ...prevs, pageLimit: value }))
                }
              />
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default MemberDetailedReport;
